import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataParser from "../../../../utlits/Dataparser";
import CompanyShiftService from "../../../../Services/CompanyShiftService";
import requests from "../../../../Services/httpService";
import UserMultiSelect from "../../../Reuseable/UserMultiSelect";
import { DatePicker, TimePicker, Tooltip, Select, message } from "antd";
import moment from "moment";
import PolicyServices from "../../../../Services/PolicyServices";
import UserService from "../../../../Services/UserService";

const { Option } = Select;

const LunchTimeModal = ({ visible, onClose, day, lunchTimes, onSave }) => {
    const [times, setTimes] = useState(lunchTimes || []);

    useEffect(() => {
        setTimes(lunchTimes || []);
    }, [lunchTimes, visible]);

    const addTime = () => {
        setTimes([...times, { start: "13:00", end: "14:00" }]);
    };

    const removeTime = (index) => {
        const newTimes = [...times];
        newTimes.splice(index, 1);
        setTimes(newTimes);
    };

    const updateTime = (index, field, value) => {
        const newTimes = [...times];
        newTimes[index][field] = value;
        setTimes(newTimes);
    };

    const handleSave = () => {
        onSave(day, times);
        onClose();
    };

    if (!visible) return null;

    return (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} onClick={onClose}>
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                    <div className="modal-header border-0 pb-1">
                        <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Manage Lunch Times for {day}</h5>
                        <button type="button" className="btn-close" onClick={onClose} />
                    </div>
                    <div className="modal-body pt-2 pb-2">
                        {times.map((t, index) => (
                            <div key={index} className="d-flex align-items-center mb-2" style={{ gap: "8px" }}>
                                <TimePicker
                                    className="shift-table-time"
                                    popupClassName="shift-table-time-popup"
                                    style={{ flex: 1 }}
                                    value={t.start ? moment(t.start, "HH:mm") : null}
                                    format="hh:mm A"
                                    use12Hours
                                    onChange={(time) => updateTime(index, "start", time ? time.format("HH:mm") : "")}
                                />
                                <span style={{ color: "#666", fontSize: "13px", flexShrink: 0 }}>to</span>
                                <TimePicker
                                    className="shift-table-time"
                                    popupClassName="shift-table-time-popup"
                                    style={{ flex: 1 }}
                                    value={t.end ? moment(t.end, "HH:mm") : null}
                                    format="hh:mm A"
                                    use12Hours
                                    onChange={(time) => updateTime(index, "end", time ? time.format("HH:mm") : "")}
                                />
                                <button
                                    type="button"
                                    onClick={() => removeTime(index)}
                                    style={{ border: "none", background: "transparent", color: "#ff4d4f", padding: "0", fontSize: "16px", flexShrink: 0, cursor: "pointer" }}
                                >
                                    <i className="uil uil-trash-alt" />
                                </button>
                            </div>
                        ))}
                        <button
                            type="button"
                            className="btn btn-sm mt-2"
                            onClick={addTime}
                            style={{ borderColor: "#0DDFAB", color: "#0DDFAB", borderRadius: "5px", fontSize: "13px" }}
                        >
                            + Add Lunch Break
                        </button>
                    </div>
                    <div className="modal-footer border-0 pt-1">
                        <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            style={{ borderRadius: "5px", fontSize: "13px" }}
                            onClick={handleSave}
                        >
                            Save changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AddCompanyShift = () => {
    const navigate = useNavigate();
    const compid = DataParser.CompanyId();

    const [dataSubmitting, setDataSubmitting] = useState(false);
    const [name, setName] = useState("");
    const [usersList, setUsersList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [allShifts, setAllShifts] = useState([]);
    const [error, setError] = useState("");

    const [shiftDays, setShiftDays] = useState({
        monday: { active: false, is_overtime_allowed: false, start: "09:00", end: "18:00", alternate: "", alternate_type: "alternate", status: "off", lunch_times: [] },
        tuesday: { active: false, is_overtime_allowed: false, start: "09:00", end: "18:00", alternate: "", alternate_type: "alternate", status: "off", lunch_times: [] },
        wednesday: { active: false, is_overtime_allowed: false, start: "09:00", end: "18:00", alternate: "", alternate_type: "alternate", status: "off", lunch_times: [] },
        thursday: { active: false, is_overtime_allowed: false, start: "09:00", end: "18:00", alternate: "", alternate_type: "alternate", status: "off", lunch_times: [] },
        friday: { active: false, is_overtime_allowed: false, start: "09:00", end: "18:00", alternate: "", alternate_type: "alternate", status: "off", lunch_times: [] },
        saturday: { active: false, is_overtime_allowed: false, start: "09:00", end: "18:00", alternate: "", alternate_type: "alternate", status: "off", lunch_times: [] },
        sunday: { active: false, is_overtime_allowed: false, start: "09:00", end: "18:00", alternate: "", alternate_type: "alternate", status: "off", lunch_times: [] },
    });

    const [conflictModal, setConflictModal] = useState({ visible: false, conflicts: [], pendingUsers: [] });
    const [lunchModalVisible, setLunchModalVisible] = useState(false);
    const [currentDayForLunch, setCurrentDayForLunch] = useState("");

    useEffect(() => {
        getCompanyUsers();
        fetchAllShifts();
    }, []);

    const fetchAllShifts = () => {
        CompanyShiftService.getAll().then((res) => {
            if (res.success) {
                setAllShifts(res.data);
            }
        });
    };

    const getCompanyUsers = () => {
        UserService.getCompanyActiveUsers(compid).then((res) => {
            const Data = res.data.users;
            let newData = [];
            for (let i = 0; i < Data.length; i++) {
                const fn = Data[i].first_name || "";
                const ln = Data[i].last_name || "";
                newData.push({
                    value: Data[i].id,
                    label: `${fn} ${ln}`.trim(),
                    initials: `${fn[0] || ""}${ln[0] || ""}`.toUpperCase(),
                });
            }
            setUsersList(newData);
        });
    };

    const handleUserChange = (selectedOptions) => {
        const isAddition = selectedOptions && selectedOptions.length > selectedUsers.length;

        if (isAddition) {
            // DETECT ALL NEW USERS (Handles "Select All")
            const addedUsers = selectedOptions.filter(opt =>
                !selectedUsers.some(su => Number(su.value) === Number(opt.value))
            );

            // Collect ALL conflicts instead of just the first one
            const conflicts = [];
            for (const addedUser of addedUsers) {
                const found = allShifts.find(shift => shift.active_users.includes(addedUser.value));
                if (found) {
                    conflicts.push({ user: addedUser, shift: found });
                }
            }

            if (conflicts.length > 0) {
                setConflictModal({ visible: true, conflicts, pendingUsers: selectedOptions });
                return;
            }
        }
        setSelectedUsers(selectedOptions);
    };

    const openLunchModal = (day) => {
        setCurrentDayForLunch(day);
        setLunchModalVisible(true);
    };

    const handleLunchSave = (day, times) => {
        setShiftDays((prev) => ({
            ...prev,
            [day.toLowerCase()]: {
                ...prev[day.toLowerCase()],
                lunch_times: times,
            },
        }));
    };

    const disabledDate = (current, dayName) => {
        if (!current) return false;
        const dayIndexMap = {
            "Sunday": 0, "Monday": 1, "Tuesday": 2, "Wednesday": 3, "Thursday": 4, "Friday": 5, "Saturday": 6
        };
        return current.day() !== dayIndexMap[dayName];
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDataSubmitting(true);

        if (!name || name.trim() === "") {
            setError("Shift Name is required!");
            setDataSubmitting(false);
            return;
        }

        const activeUsers = selectedUsers.map((u) => u.value);

        const formattedDays = Object.entries(shiftDays).map(([dayKey, data]) => ({
            day: dayKey.charAt(0).toUpperCase() + dayKey.slice(1),
            active: data.active || false,
            is_overtime_allowed: data.is_overtime_allowed || false,
            start: data.start || "",
            end: data.end || "",
            alternate: data.alternate || "",
            alternate_type: data.alternate_type || "alternate",
            status: data.status || "off",
            lunch_times: data.lunch_times || []
        }));

        const Body = {
            company_id: compid,
            name: name.trim(),
            active_users: activeUsers,
            days: formattedDays
        };

        try {
            const resp = await CompanyShiftService.create(Body);
            if (resp.success) {
                message.success("Shift Created Successfully!");
                navigate(`/${DataParser.CompanyIdentifierRole()}/company_shifts`);
            } else {
                message.error(resp.data.message || "Failed to create Shift");
            }
        } catch (err) {
            console.error(err);
            message.error(err?.response?.data?.message || "Something went wrong!");
        } finally {
            setDataSubmitting(false);
        }
    };

    return (
        <>
            <div className="main-content">
                <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
                    <div className="container-fluid">

                        <LunchTimeModal
                            visible={lunchModalVisible}
                            day={currentDayForLunch}
                            lunchTimes={shiftDays[currentDayForLunch.toLowerCase()]?.lunch_times || []}
                            onClose={() => setLunchModalVisible(false)}
                            onSave={handleLunchSave}
                        />

                        {conflictModal.visible && (
                            <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} onClick={() => setConflictModal({ visible: false, conflicts: [], pendingUsers: [] })}>
                                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "420px" }} onClick={e => e.stopPropagation()}>
                                    <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                                        <div className="modal-header border-0 pb-1">
                                            <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Conflict Detected</h5>
                                            <button type="button" className="btn-close" onClick={() => setConflictModal({ visible: false, conflicts: [], pendingUsers: [] })} />
                                        </div>
                                        <div className="modal-body pt-2 pb-2">
                                            {conflictModal.conflicts.length > 1 ? (
                                                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "10px" }}>
                                                    <strong>Multiple users</strong> ({conflictModal.conflicts.length}) are already assigned to other shifts.
                                                </p>
                                            ) : (
                                                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "10px" }}>
                                                    User <strong>{conflictModal.conflicts[0]?.user.label}</strong> is already assigned to:
                                                </p>
                                            )}
                                            <div style={{
                                                background: "#fff7e6", border: "1px solid #ffd591",
                                                borderRadius: "6px", padding: "8px 12px",
                                                fontWeight: "600", color: "#d46b08", marginBottom: "10px"
                                            }}>
                                                {conflictModal.conflicts.length > 1 ? "Various Existing Shifts" : conflictModal.conflicts[0]?.shift.name}
                                            </div>
                                            <p style={{ fontSize: "13px", color: "#8c8c8c", marginBottom: 0 }}>
                                                {conflictModal.conflicts.length > 1
                                                    ? "Would you like to reassign all of them to this shift?"
                                                    : "Would you like to reassign them to this shift?"}
                                            </p>
                                        </div>
                                        <div className="modal-footer border-0 pt-1">
                                            <button
                                                type="button"
                                                className="btn btn-light"
                                                style={{ borderRadius: "5px", fontSize: "13px", border: "none" }}
                                                onClick={() => setConflictModal({ visible: false, conflicts: [], pendingUsers: [] })}
                                            >
                                                Keep Current
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary waves-effect waves-light"
                                                style={{ borderRadius: "5px", fontSize: "13px" }}
                                                onClick={() => {
                                                    setSelectedUsers(conflictModal.pendingUsers);
                                                    setConflictModal({ visible: false, conflicts: [], pendingUsers: [] });
                                                }}
                                            >
                                                Reassign
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="d-flex justify-content-end" style={{ padding: "8px 0" }}>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to={`/${DataParser.CompanyIdentifierRole()}/company_shifts`}>Company Shifts</Link>
                                        </li>
                                        <li className="breadcrumb-item active">Create</li>
                                    </ol>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                                    <div className="card-body p-0 pt-3">

                                        <div className="row mb-2" style={{ alignItems: "flex-start" }}>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <div className="float-input-wrap">
                                                        <input
                                                            type="text"
                                                            className={error ? "is-invalid" : ""}
                                                            id="shiftName"
                                                            placeholder=" "
                                                            value={name}
                                                            onChange={(e) => {
                                                                setName(e.target.value);
                                                                if (e.target.value.trim() !== "") setError("");
                                                            }}
                                                        />
                                                        <label htmlFor="shiftName">Shift Name*</label>
                                                    </div>
                                                    {error && <small className="text-danger mt-1 d-block">{error}</small>}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <UserMultiSelect
                                                    options={usersList}
                                                    value={selectedUsers}
                                                    onChange={handleUserChange}
                                                    label="Assign to Users"
                                                    allowSelectAll
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                                <h5 className="mb-3 mt-0">Shift Plan</h5>
                                                <div className="table-responsive listing-table-wrapper">
                                                    <table className="table mb-0 align-middle custom-table listing-table shift-plan-table">
                                                        <thead style={{
                                                            textAlign: "center",
                                                        }}>
                                                            <tr className="tableHeaderbg text-center">
                                                                <th style={{ width: "6%", whiteSpace: "nowrap", padding: "8px", textAlign: "center" }}>
                                                                    Day
                                                                    <Tooltip title="Day of the week">
                                                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#242424', cursor: 'help' }} />
                                                                    </Tooltip>
                                                                </th>
                                                                <th style={{ width: "12%", whiteSpace: "nowrap", padding: "8px", textAlign: "center" }}>
                                                                    Shift Start Time
                                                                    <Tooltip title="Starting time for this shift">
                                                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#242424', cursor: 'help' }} />
                                                                    </Tooltip>
                                                                </th>
                                                                <th style={{ width: "12%", whiteSpace: "nowrap", padding: "8px", textAlign: "center" }}>
                                                                    Shift End Time
                                                                    <Tooltip title="Ending time for this shift">
                                                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#242424', cursor: 'help' }} />
                                                                    </Tooltip>
                                                                </th>
                                                                <th style={{ width: "8%", whiteSpace: "nowrap", padding: "8px", textAlign: "center" }}>
                                                                    Lunch
                                                                    <Tooltip title="Manage lunch breaks for this day">
                                                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#242424', cursor: 'help' }} />
                                                                    </Tooltip>
                                                                </th>
                                                                <th style={{ width: "15%", whiteSpace: "nowrap", padding: "8px", textAlign: "center" }}>
                                                                    First Alternate Date
                                                                    <Tooltip title="Specific date for the first alternate off/on occurrence.">
                                                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#242424', cursor: 'help' }} />
                                                                    </Tooltip>
                                                                </th>
                                                                <th style={{ width: "10%", whiteSpace: "nowrap", padding: "8px", textAlign: "center" }}>
                                                                    Alternate Status
                                                                    <Tooltip title="Status for alternate occurrence (On/Off)" placement="topRight">
                                                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#242424', cursor: 'help' }} />
                                                                    </Tooltip>
                                                                </th>
                                                                <th style={{ width: "14%", whiteSpace: "nowrap", padding: "8px", textAlign: "center" }}>
                                                                    Alternate Type
                                                                    <Tooltip title="Frequency of alternate occurrence" placement="topRight">
                                                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#242424', cursor: 'help' }} />
                                                                    </Tooltip>
                                                                </th>
                                                                <th style={{ width: "18%", whiteSpace: "nowrap", padding: "8px", textAlign: "center" }}>
                                                                    Status
                                                                    <Tooltip title="Shift state (Working, Off, or OT Allowed Off-day)" placement="topRight">
                                                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#242424', cursor: 'help' }} />
                                                                    </Tooltip>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {[
                                                                "Monday",
                                                                "Tuesday",
                                                                "Wednesday",
                                                                "Thursday",
                                                                "Friday",
                                                                "Saturday",
                                                                "Sunday",
                                                            ].map((day) => (
                                                                <tr key={day}>
                                                                    <td className="fw-semibold text-center">{day}</td>

                                                                    <td>
                                                                        <TimePicker
                                                                            className="shift-table-time"
                                                                            popupClassName="shift-table-time-popup"
                                                                            style={{ width: "100%" }}
                                                                            placeholder="Select Time"
                                                                            value={shiftDays?.[day.toLowerCase()]?.start ? moment(shiftDays?.[day.toLowerCase()]?.start, "HH:mm") : null}
                                                                            format="hh:mm A"
                                                                            use12Hours
                                                                            onChange={(time) =>
                                                                                setShiftDays((prev) => ({
                                                                                    ...prev,
                                                                                    [day.toLowerCase()]: {
                                                                                        ...prev[day.toLowerCase()],
                                                                                        start: time ? time.format("HH:mm") : "",
                                                                                    },
                                                                                }))
                                                                            }
                                                                            disabled={!shiftDays?.[day.toLowerCase()]?.active && !shiftDays?.[day.toLowerCase()]?.is_overtime_allowed}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <TimePicker
                                                                            className="shift-table-time"
                                                                            popupClassName="shift-table-time-popup"
                                                                            style={{ width: "100%" }}
                                                                            placeholder="Select Time"
                                                                            value={shiftDays?.[day.toLowerCase()]?.end ? moment(shiftDays?.[day.toLowerCase()]?.end, "HH:mm") : null}
                                                                            format="hh:mm A"
                                                                            use12Hours
                                                                            onChange={(time) =>
                                                                                setShiftDays((prev) => ({
                                                                                    ...prev,
                                                                                    [day.toLowerCase()]: {
                                                                                        ...prev[day.toLowerCase()],
                                                                                        end: time ? time.format("HH:mm") : "",
                                                                                    },
                                                                                }))
                                                                            }
                                                                            disabled={!shiftDays?.[day.toLowerCase()]?.active && !shiftDays?.[day.toLowerCase()]?.is_overtime_allowed}
                                                                        />
                                                                    </td>

                                                                    <td className="text-center">
                                                                        <button
                                                                            className="btn btn-sm"
                                                                            onClick={() => openLunchModal(day)}
                                                                            disabled={!shiftDays?.[day.toLowerCase()]?.active && !shiftDays?.[day.toLowerCase()]?.is_overtime_allowed}
                                                                            style={{ border: "none", background: "transparent", color: "#0DDFAB", padding: "0" }}
                                                                        >
                                                                            <i className="fa fa-plus" style={{ fontSize: "16px" }}></i>
                                                                        </button>
                                                                    </td>

                                                                    <td>
                                                                        <DatePicker
                                                                            size="small"
                                                                            placeholder="Select Date"
                                                                            value={shiftDays?.[day.toLowerCase()]?.alternate ? moment(shiftDays?.[day.toLowerCase()]?.alternate) : null}
                                                                            suffixIcon={
                                                                                shiftDays?.[day.toLowerCase()]?.alternate ? (
                                                                                    <div
                                                                                        style={{
                                                                                            position: "absolute", top: "50%", right: "0px", transform: "translateY(-50%)",
                                                                                            zIndex: 1000, cursor: "pointer", pointerEvents: "auto", background: "white", padding: "2px",
                                                                                            display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%",
                                                                                            width: "20px", height: "20px"
                                                                                        }}
                                                                                        onMouseDown={(e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();
                                                                                            setShiftDays((prev) => ({
                                                                                                ...prev,
                                                                                                [day.toLowerCase()]: { ...prev[day.toLowerCase()], alternate: "" },
                                                                                            }));
                                                                                        }}
                                                                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                                                                    >
                                                                                        <i className="fa fa-times-circle" style={{ color: "gray", fontSize: "14px" }} title="Clear Date" />
                                                                                    </div>
                                                                                ) : (
                                                                                    <i className="fa fa-calendar" style={{ color: "rgba(0,0,0,0.25)" }} />
                                                                                )
                                                                            }
                                                                            onChange={(date, dateString) =>
                                                                                setShiftDays((prev) => ({
                                                                                    ...prev,
                                                                                    [day.toLowerCase()]: {
                                                                                        ...prev[day.toLowerCase()],
                                                                                        alternate: dateString,
                                                                                    },
                                                                                }))
                                                                            }
                                                                            disabled={!shiftDays?.[day.toLowerCase()]?.active && !shiftDays?.[day.toLowerCase()]?.is_overtime_allowed}
                                                                            disabledDate={(current) => disabledDate(current, day)}
                                                                            style={{ width: "100%" }}
                                                                        />
                                                                    </td>

                                                                    <td className="text-center">
                                                                        <div className="form-check form-switch d-flex justify-content-center">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                checked={shiftDays?.[day.toLowerCase()]?.status === "on"}
                                                                                onChange={(e) =>
                                                                                    setShiftDays((prev) => ({
                                                                                        ...prev,
                                                                                        [day.toLowerCase()]: {
                                                                                            ...prev[day.toLowerCase()],
                                                                                            status: e.target.checked ? "on" : "off",
                                                                                        },
                                                                                    }))
                                                                                }
                                                                                disabled={!shiftDays?.[day.toLowerCase()]?.active && !shiftDays?.[day.toLowerCase()]?.is_overtime_allowed}
                                                                            />
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <Select
                                                                            className="shift-table-select"
                                                                            popupClassName="shift-table-select-dropdown"
                                                                            style={{ width: "100%" }}
                                                                            placeholder="Alternate Type"
                                                                            value={shiftDays?.[day.toLowerCase()]?.alternate_type || "alternate"}
                                                                            onChange={(val) =>
                                                                                setShiftDays((prev) => ({
                                                                                    ...prev,
                                                                                    [day.toLowerCase()]: {
                                                                                        ...prev[day.toLowerCase()],
                                                                                        alternate_type: val,
                                                                                    },
                                                                                }))
                                                                            }
                                                                            disabled={!shiftDays?.[day.toLowerCase()]?.active && !shiftDays?.[day.toLowerCase()]?.is_overtime_allowed}
                                                                        >
                                                                            <Option value="alternate">alternate</Option>
                                                                            <Option value="bialternate">bialternate</Option>
                                                                            <Option value="trialternate">trialternate</Option>
                                                                            <Option value="monthly alternate">monthly alternate</Option>
                                                                        </Select>
                                                                    </td>

                                                                     <td>
                                                                        <Select
                                                                            className="shift-table-select"
                                                                            popupClassName="shift-table-select-dropdown"
                                                                            style={{ width: "100%" }}
                                                                            placeholder="Status"
                                                                            value={
                                                                                shiftDays?.[day.toLowerCase()]?.active
                                                                                    ? "working"
                                                                                    : shiftDays?.[day.toLowerCase()]?.is_overtime_allowed
                                                                                        ? "off_ot"
                                                                                        : "off"
                                                                            }
                                                                            onChange={(val) => {
                                                                                setShiftDays((prev) => ({
                                                                                    ...prev,
                                                                                    [day.toLowerCase()]: {
                                                                                        ...prev[day.toLowerCase()],
                                                                                        active: val === "working",
                                                                                        is_overtime_allowed: val === "off_ot",
                                                                                    },
                                                                                }));
                                                                            }}
                                                                        >
                                                                            <Option value="working">Working Day</Option>
                                                                            <Option value="off">Off Day</Option>
                                                                            <Option value="off_ot">Off Day (OT Allowed)</Option>
                                                                        </Select>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mt-4">
                                            <div className="col-12 text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary dbtn"
                                                    disabled={dataSubmitting}
                                                    onClick={handleSubmit}
                                                >
                                                    {dataSubmitting ? "Creating..." : "Create Shift"}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default AddCompanyShift;
